export enum SalaryComponentType {
  Odpracovano = "Odpracovano",
  OdpracovanoSvatek = "OdpracovanoSvatek",
  OdpracovanoNoc = "OdpracovanoNoc",
  OdpracovanoSobota = "OdpracovanoSobota",
  OdpracovanoNedele = "OdpracovanoNedele",
  VybranaDovolena = "VybranaDovolena",
  ZakladniOdmena = "ZakladniOdmena",
  PriplatekZaSvatek = "PriplatekZaSvatek",
  PriplatekZaNoc = "PriplatekZaNoc",
  PriplatekZaSobotu = "PriplatekZaSobotu",
  PriplatekZaNedeli = "PriplatekZaNedeli",
  KorekceHruba = "KorekceHruba",
  NahradaZaDovolenou = "NahradaZaDovolenou",
  KorekceOdmeny = "KorekceOdmeny",
  HrubaOdpracovana = "HrubaOdpracovana",
  HrubaOdmeny = "HrubaOdmeny",
  Hruba = "Hruba",
  MinimalniZdravotniPojisteni = "MinimalniZdravotniPojisteni",
  DoplatekNaMinimalniZdravotniPojisteni = "DoplatekNaMinimalniZdravotniPojisteni",
  SlevaNaPoplatnika = "SlevaNaPoplatnika",
  SlevaNaStudenta = "SlevaNaStudenta",
  SlevaProInvalidniDuchodce = "SlevaProInvalidniDuchodce",
  SlevaProZTPP = "SlevaProZTPP",
  SlevaNaDaniCelkem = "SlevaNaDaniCelkem",
  ZalohovaDanZPrijmu = "ZalohovaDanZPrijmu",
  SrazkovaDanZPrijmu = "SrazkovaDanZPrijmu",
  ZdravotniPojisteni = "ZdravotniPojisteni",
  SocialniPojisteni = "SocialniPojisteni",
  KorekceCista = "KorekceCista",
  Cista = "Cista",
  VyplatitelneMaximum = "VyplatitelneMaximum",
  Exekuce = "Exekuce",
  ZakladProZalohy = "ZakladProZalohy",
  ZadrzeneOdvodyDpc = "ZadrzeneOdvodyDpc",
  PriznaneZalohy = "PriznaneZalohy",
  VyplaceneZalohy = "VyplaceneZalohy",
  KorekceKVyplate = "KorekceKVyplate",
  KVyplate = "KVyplate",
  ZdravotniPojisteniPlaceneZamestnavatelem = "ZdravotniPojisteniPlaceneZamestnavatelem",
  SocialniPojisteniPlaceneZamestnavatelem = "SocialniPojisteniPlaceneZamestnavatelem",
  Superhruba = "Superhruba",
  NakladyZamestnavatele = "NakladyZamestnavatele",
}
